// extracted by mini-css-extract-plugin
export default {"expected-growth-holder":"ExpectedGrowth_expected-growth-holder__HDN4h","expected-growth-info":"ExpectedGrowth_expected-growth-info__i1Tm8"};